<template>
  <div>
    <h2 class="page-title-bar">
      <img class="imgageproperty" src="@/assets/img/errorlist.png" alt="save" />
      {{ $t("ESL Statistics") }}
    </h2>

    <div class="searchArea">
        <v-menu
        v-model="showStartDatePicker"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="searchBy.startDate"
            @click:clear="clearDate(searchBy, 'startDate')"
            :label="`${$t('Period')}`"
            :placeholder="`${$t('Select start date')}`"
            class="form-input ml-3"
            v-bind="attrs"
            v-on="on"
            outlined
            dense
            hide-details
            readonly
          >
            <template v-slot:append>
              <img width="16" height="16" src="@/assets/img/ico-calendar.png" />
            </template>
          </v-text-field>
        </template>
        <v-date-picker
          v-model="searchBy.startDate"
          @change="checkStartDate"
          :locale="languageCodes[$store.getters['dataStore/GET_CURRENT_LANGUAGE']]"
          @input="showStartDatePicker = false"
          no-title
        ></v-date-picker>
      </v-menu>
      <span class="ml-1 mr-1">~</span>
      <v-menu
        v-model="showEndDatePicker"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="searchBy.endDate"
            @click:clear="clearDate(searchBy, 'endDate')"
            v-bind="attrs"
            v-on="on"
            :placeholder="`${$t('Select end date')}`"
            class="form-input"
            outlined
            dense
            hide-details
            solo
            readonly
          >
            <template v-slot:append>
              <img width="16" height="16" src="@/assets/img/ico-calendar.png" />
            </template>
          </v-text-field>
        </template>
        <v-date-picker
          v-model="searchBy.endDate"
          :locale="languageCodes[$store.getters['dataStore/GET_CURRENT_LANGUAGE']]"
          @change="checkEndDate"
          @input="showEndDatePicker = false"
          no-title
        ></v-date-picker>
      </v-menu>
       <v-btn text class="btn type-search ml-3"  @click="getStatisticsInfo(1)">{{
        $t('Search')
      }}</v-btn>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :hide-default-footer="true"
      class="tbl-type01 mt-10"
      return-object
    >
      <template slot="no-data">
        <p>{{ $t("No data available") }}</p>
      </template>
    </v-data-table>

    <div class="table-options">
      <div>
        <v-btn
          :disabled="btnDisabledExportCheckList || exportDisabled"
          @click="exportUserInfoList"
          class="btn ml-2"
          text
        >
          {{ $t("Export") }}
        </v-btn>
      </div>
    </div>
    <a ref="link" :style="{ display: 'none' }" />
  </div>
</template>

<script>
import EventBus from '@/plugins/eventBus'
import { mapGetters } from 'vuex'
import commons from '@/plugins/commons'
import moment from 'moment'

const requests = {
  getStatisticsInfo: {
    method: 'get',
    url: '/metro/report/static-report'
  },
  getPdfStatisticsInfo: {
    method: 'post',
    url: '/metro/report/static-report-pdf'
  }
}

export default {
  name: 'ESLProductInfo',

  data () {
    return {
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      btnDisabledExport: null,
      pageCount: 0,
      tableItems: [],
      selected: [],
      options: {},
      ROW_CLASS: 'row-class',
      page: 1,
      totalPages: 0,
      pageInfoText: null,
      totalVisiblePages: 7,
      exportDisabled: false,
      userEditItem: {},
      requestConfig: {},
      searchParam: {
        company: null,
        store: null,
        page: null,
        size: '10',
        sort: 'code,asc'
      },
      showStartDatePicker: false,
      showEndDatePicker: false,
      searchBy: {
        fileName: null,
        startDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      languageCodes: {
        English: 'en',
        한국어: 'ko',
        Deutsch: 'de',
        Francais: 'fr',
        中文: 'zh',
        Espanol: 'es',
        Italiano: 'it',
        Portugal: 'por',
        日本語: 'jp'
      },
      startIndex: null,
      totalData: [],
      endindex: null,
      lastUpdatedTime: null
    }
  },
  computed: {
    tableHeaders () {
      return [
        {
          text: this.$t('DATE'),
          sortable: false,
          align: 'center',
          value: 'updateDate',
          width: '95px'
        },
        {
          text: this.$t('UPDATE'),
          sortable: false,
          align: 'center',
          value: 'updatedCount',
          width: '85px'
        },
        {
          text: this.$t('PRICE UPDATE'),
          sortable: false,
          value: 'priceUpdateCount',
          align: 'center',
          width: '85px'
        },
        {
          text: this.$t('ESL LINK'),
          sortable: false,
          align: 'center',
          value: 'linkCount',
          width: '95px'
        },
        {
          text: this.$t('ESL UNLINK'),
          sortable: false,
          value: 'unlinkCount',
          width: '90px',
          align: 'center'
        },
        {
          text: this.$t('ESL ON ERROR REPORT'),
          sortable: false,
          value: 'eslErrorCount',
          width: '90px',
          align: 'center'
        }
      ]
    },
    btnDisabledExportCheckList () {
      var flag = true
      if (this.tableItems !== undefined && this.tableItems.length) flag = false
      return flag
    },
    ...mapGetters({ store: 'dataStore/GET_SELECTED_STORE' }),
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    }
  },
  watch: {
    store: {
      handler () {
        this.page = 1
        this.getStatisticsInfo(this.page)
      }
    }
  },
  created () {
    this.user = this.$store.state.auth.user
  },
  mounted () {
    this.getStatisticsInfo(1)
    this.$store.dispatch('auth/getDisabledBtn', '11400').then((flag) => {
      this.exportDisabled = flag
    })
    EventBus.$emit('enableSelectedStores', true)
    if (!this.store.code) {
      EventBus.$emit('openSelectedStores')
    } else {
      this.getStatisticsInfo(1)
    }
  },
  methods: {
    paging (page) {
      this.getStatisticsInfo(page)
    },
    checkStartDate (val) {
      if (val > this.searchBy.endDate) {
        this.searchBy.startDate = null
        EventBus.$emit(
          'messageAlert',
          this.$t('The start date is must be prior to the end date.')
        )
      }
    },
    checkEndDate (val) {
      if (val < this.searchBy.startDate) {
        this.searchBy.endDate = null
        EventBus.$emit(
          'messageAlert',
          this.$t('The end date is must be after the start date.')
        )
      }
    },
    exportUserInfoList () {
      const exportdata = {
        guiMap: {
          Date: this.$t('DATE'),
          updatedCount: this.$t('UPDATED COUNT'),
          priceUpdateCount: this.$t('PRICE UPDATE COUNT'),
          linkCount: this.$t('LINK COUNT'),
          unlinkCount: this.$t('UNLINK COUNT'),
          eslErrorCount: this.$t('ESL ERROR COUNT'),
          store_name: this.$t('STORE NAME'),
          title_staticreport: this.$t('STATIC REPORT')
        },
        msgMap: {
          M0124: this.$t('date Edited'),
          M0125: this.$t('Signature Dept. Head'),
          M0126: this.$t('Error Code'),
          M0127: this.$t('ESL No'),
          M0128: this.$t('ESL no reception'),
          M0129: this.$t('ESL with an incorrect price'),
          M0130: this.$t('ESL false indication info level'),
          M0131: this.$t('Destroyed ESL'),
          M0132: this.$t('Other')
        }
      }

      const params = { company: this.user.company, store: this.store.code, lang: this.$store.getters['dataStore/GET_CURRENT_LANGUAGE'] }
      params.fromDate = this.searchBy.startDate
      params.toDate = this.searchBy.endDate
      const config = { params: params }
      config.responseType = 'arraybuffer'
      this.$utils
        .callAxiosWithBody(
          requests.getPdfStatisticsInfo.method,
          requests.getPdfStatisticsInfo.url,
          exportdata,
          config
        )
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'statisticsInfo.pdf'
          link.click()
        })
        .catch(error => {
          console.debug(error)
        })
    },
    insertIndex (tableData, headers) {
      let idx = Number(headers['x-number'] * headers['x-size']) + 1
      tableData = tableData.map((tableItems) => {
        tableItems.no = idx
        idx++
        return tableItems
      })
      return tableData
    },
    handlegetStatisticsInfoResponse (res) {
      console.log(res)
      if (res.status === 204) {
        this.handlegetStatisticsInfoError('No content')
        return
      }
      this.tableItems = []
      this.tableItems.push(res.data)
    },
    handlegetStatisticsInfoError (error) {
      this.tableItems = []
      const headers = {}
      headers['x-totalelements'] = 0
      this.pageInfoText = this.getPageInfoText(headers)
      this.totalPages = 0
      console.debug(error)
    },
    buildParmas: function () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      const params = { company: this.user.company, store: this.store.code }
      let sort = null
      if (sortBy && sortBy.length === 1 && sortDesc && sortDesc.length === 1) {
        const sortKey = sortBy[0]
        const sortOrder = sortDesc[0]
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      if (itemsPerPage > 0) params.size = itemsPerPage
      return params
    },
    getStatisticsInfo (page) {
      const params = this.buildParmas()
      if (page !== null) params.page = page - 1
      params.fromDate = this.searchBy.startDate
      params.toDate = this.searchBy.endDate
      const config = { params: params }
      if (commons.isNull(config.params.store) || config.params.store === '') {
        this.handlegetStatisticsInfoError('')
        return
      }
      this.$utils
        .callAxios(
          requests.getStatisticsInfo.method,
          requests.getStatisticsInfo.url,
          config
        )
        .then((res) => {
          this.handlegetStatisticsInfoResponse(res)
        })
        .catch((error) => {
          this.handlegetStatisticsInfoError(error)
        })
    }
  }
}
</script>

<style scoped>
.v-input {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  font-size: 12px;
  letter-spacing: normal;
  max-width: 18% !important;
  text-align: left;
}
.lastupdated1 {
  position: absolute;
  right: 46px;
  margin-top: -18px;
  font-size: 14px;
}
.lastupdateddate1 {
  position: absolute;
  right: 46px;
  font-size: 14px;
}
/* .v-application .mt-10 {
  margin-top: 0px !important;
} */
.v-application .text-center {
  text-align: left !important;
}
.imgageproperty {
  margin-right: 14px;
  height: 24px;
}
</style>
